import { Client, UserClient } from '../api/app-types/client.app';
import { DashboardItem } from '../api/app-types/dashboard.app';
import { PERSON_TYPE } from '../api/app-types/search.app';

export const mockClient: Client = {
	id: 123,
	name: 'Test Client',
	uuid: 'test-uuid',
	gender: { id: 1, salutation: 'Male', initials: 'M', salutationSuggestion: 'Mr.' },
	address: {
		id: 1,
		postalCodeAndCity: '12345 Test City',
		streetAndHouseNumber: 'Test Street 123',
		anonym: '',
		identifier: '',
		soundexStreet: '',
	},
};

export const mockDashboardClient: DashboardItem = {
	id: 1,
	fullName: 'Max Mustermann',
	ifdName: '',
	serviceName: '',
	personType: PERSON_TYPE.CLIENT,
	activeAssignments: [
		{
			activeAssignmentId: 2,
			isAdditionalAssignment: true,
			isServiceOfficeStatement: false,
			phase: { id: 3, remark: 'P2' },
			lastContact: '01.01.2024',
			currentPhaseStart: '02.01.2024',
			dueDate: '03.01.2024',
			typeOfCare: undefined,
		},
		{
			activeAssignmentId: 1,
			isAdditionalAssignment: false,
			isServiceOfficeStatement: false,
			phase: { id: 4, remark: 'P3' },
			lastContact: '03.01.2024',
			currentPhaseStart: '04.01.2024',
			dueDate: '05.01.2024',
			typeOfCare: 'Care A',
		},
	],
	activeAssignmentForTheUserCount: 5,
};

export const mockDashboardUsers: DashboardItem[] = [
	{
		id: 1,
		fullName: 'Anna Müller',
		personType: PERSON_TYPE.USER,
		ifdName: 'IFD Stuttgart',
		serviceName: 'Consulting',
		activeAssignments: [],
		activeAssignmentForTheUserCount: 5,
	},
	{
		id: 2,
		fullName: 'John Smith',
		personType: PERSON_TYPE.USER,
		ifdName: 'IFD Ulm',
		serviceName: 'Support',
		activeAssignments: [],
		activeAssignmentForTheUserCount: 5,
	},
	{
		id: 3,
		fullName: 'María García',
		personType: PERSON_TYPE.USER,
		ifdName: 'IFD Karlsruhe',
		serviceName: 'Rehabilitation',
		activeAssignments: [],
		activeAssignmentForTheUserCount: 5,
	},
	{
		id: 4,
		fullName: 'Luca Rossi',
		personType: PERSON_TYPE.USER,
		ifdName: 'IFD Freiburg',
		serviceName: 'Coordination',
		activeAssignments: [],
		activeAssignmentForTheUserCount: 5,
	},
	{
		id: 5,
		fullName: 'Zoë Peterson',
		personType: PERSON_TYPE.USER,
		ifdName: 'IFD Mannheim',
		serviceName: 'Therapy',
		activeAssignments: [],
		activeAssignmentForTheUserCount: 5,
	},
];

export const mockUserClients: UserClient[] = [
	{
		id: 1,
		clientFullName: 'Anna Müller',
		assignments: [
			{
				id: 101,
				assignmentGuid: 'A-101',
				phase: 'P3',
				currentPhaseStart: '2026-01-15',
				ownerFullName: 'John Doe',
				assignmentType: 'AT',
				validOperation: 'move-active',
			},
			{
				id: 111,
				assignmentGuid: 'A-111',
				phase: 'P4',
				currentPhaseStart: '2026-01-20',
				ownerFullName: 'John Doe',
				assignmentType: 'AT',
				validOperation: 'no-operation-detected',
			},
			{
				id: 112,
				assignmentGuid: '',
				phase: 'P0',
				currentPhaseStart: '',
				ownerFullName: 'John Doe',
				assignmentType: 'AT',
				validOperation: 're-ownership',
			},
		],
	},
	{
		id: 2,
		clientFullName: 'María García',
		assignments: [
			{
				id: 102,
				assignmentGuid: 'ASSIGN-a91c44',
				phase: 'Follow-up',
				currentPhaseStart: '2026-02-01',
				ownerFullName: 'Sophie Dubois',
				assignmentType: 'Rehabilitation',
				validOperation: 'move-active',
			},
			{
				id: 103,
				assignmentGuid: 'ASSIGN-b72d19',
				phase: 'Planning',
				currentPhaseStart: '2026-02-20',
				ownerFullName: 'Luca Rossi',
				assignmentType: 'Additional Support',
				validOperation: 'move-active',
			},
		],
	},
	{
		id: 3,
		clientFullName: 'Zoë Peterson',
		assignments: [],
	},
	{
		id: 4,
		clientFullName: 'Maximilian Alexander von Hohenberg',
		assignments: [
			{
				id: 104,
				assignmentGuid: 'ASSIGN-c55e02',
				phase: 'Active Care',
				currentPhaseStart: '2026-03-01',
				ownerFullName: 'İbrahim Yılmaz',
				assignmentType: 'Long-Term Care',
				validOperation: 'move-active',
			},
		],
	},
];
